import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKampanyaDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKampanyaDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  SelectCampaignsById: any[];
  SelectCampaignsById_dummy: any[];
}

export class KampanyaDetay_ScreenBase extends React.PureComponent<
  IKampanyaDetay_ScreenProps,
  any
> {
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "eb4979da-a99f-4e52-b84c-60c94930ec1e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 661275, PropertyName: "value", Value: "Kampanya Detay" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectCampaignsById: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kampanyadetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KampanyaDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kampanyadetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kampanyadetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KampanyaDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kampanyadetay_33632_value:
        this.state.SelectCampaignsById?.at?.(0)?.imageUrl ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KampanyaDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CampaignID ??
          this.props.screenInputs.campaignid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KampanyaDetay/KampanyaDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectCampaignsById = result?.data.selectCampaignsById;
    formVars.kampanyadetay_33632_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].imageUrl
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].imageUrl
        : null
    );
    formVars.kampanyadetay_816987_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].campaignCode
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].campaignCode
        : null
    );
    formVars.kampanyadetay_861891_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].startDate
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].startDate
        : null
    );
    formVars.kampanyadetay_384773_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].endDate
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].endDate
        : null
    );
    formVars.kampanyadetay_653471_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].title
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].title
        : null
    );
    formVars.kampanyadetay_472176_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].content
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].content
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KampanyaDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KampanyaDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kampanyadetay_33632_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].imageUrl
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].imageUrl
        : null
    );

    formVars.kampanyadetay_816987_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].campaignCode
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].campaignCode
        : null
    );

    formVars.kampanyadetay_861891_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].startDate
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].startDate
        : null
    );

    formVars.kampanyadetay_384773_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].endDate
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].endDate
        : null
    );

    formVars.kampanyadetay_653471_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].title
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].title
        : null
    );

    formVars.kampanyadetay_472176_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCampaignsById !== undefined
        ? stateVars.SelectCampaignsById?.length > 0
          ? stateVars.SelectCampaignsById[0].content
          : null
        : this.state.SelectCampaignsById?.length > 0
        ? this.state.SelectCampaignsById[0].content
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KampanyaDetayComponent_955977_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KampanyaDetayPageInit();
    }
  }
}
